// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__35E_u","inputWrap":"Table_inputWrap__1yAFE","col":"Table_col__2cjZJ","bmiTooltip":"Table_bmiTooltip__aSNau"};